import React from 'react';
import QED from './qed-table.js';
import classNames from 'classnames';



export default class extends React.Component {

    constructor(props) {

        super(props);

        this.log = console.log;

        this.log('constructing DataTable');

        let {sortBy = undefined, selection = {}, sortOrder = undefined, filter = '', rows, columns} = props;

        this.rows = rows;
        this.columns = columns;
        this.state = {};
        this.state.rows = null;
        this.state.rowFilter = null;
        this.state.sortOrder = sortOrder;
        this.state.sortBy = sortBy;

        this.state.rowOrder = this.rows.map((row, index) => {
            return index;
        });

        
        this.state.filter = filter;
        this.state.rowFilter = this.computeRowFilter(filter);
        this.state.rowOrder = this.computeRowOrder(sortBy, sortOrder);
        this.state.rowSelection = selection;

    }

    renderCell(cell, rowIndex, columnIndex) {
        let props = {};
        props.key = columnIndex;
        props.index = columnIndex;
        props.align = this.columns[columnIndex].align;

        return (
            <QED.Cell {...props}>
                {cell}
            </QED.Cell>
        );

    }

    renderRow(row, rowIndex) {

        let props = {};

        props.key = rowIndex;
        props.index = rowIndex;
        props.className = '';

        if (this.state.rowSelection[rowIndex])
            props.className = classNames(props.className, 'table-primary ');

        props.onClick = (event) => {
            let target = event.target.parentNode;
            let index = target.attributes['index'].value;
            let row = this.props.rows[index];

            let rowSelection = this.state.rowSelection;

            this.log('DataTable - onClick', target);

            switch(this.props.selectionStyle) {
                case 'multiple': {
                    if (rowSelection[index])
                        delete rowSelection[index];
                    else
                        rowSelection[index] = row;
                    break;
                }
                case 'single': {
                    rowSelection = {};
                    rowSelection[index] = row;
                    break;
                }

            }

            if (typeof this.props.onSelectionChange == 'function') {
                let selectedRows = [];
                
                for (let key in rowSelection) {
                    selectedRows.push(this.props.rows[key]);
                }

                this.props.onSelectionChange(selectedRows);
            }

            this.setState({rowSelection:rowSelection});
        };


        let cells = this.props.columns.map((column, columnIndex) => {

            let content = undefined;

            if (content == undefined)
                content = column.content;

            if (content == undefined)
                content = column.text; 

            if (content == undefined)
                content = column.value; 

            if (typeof(content) == 'function') 
                content = content(row, rowIndex, columnIndex)

            return this.renderCell(content, rowIndex, columnIndex);
        });

        return (
            <QED.Row {...props}>
                {cells}
            </QED.Row>
        );
    }

    renderRows() {

        return this.props.rows.map((row, rowIndex) => {
            
            try {
                // Translate the row index accordning to sorting
                if (this.state.rowOrder) {
                    rowIndex = this.state.rowOrder[rowIndex];
                    row = this.props.rows[rowIndex];
                }

                if (!this.state.rowFilter || this.state.rowFilter[rowIndex])
                    return this.renderRow(row, rowIndex);

            }
            catch(error) {
                debugger;
            }
        });            

    }

    renderColumn(column, columnIndex) {

        let props = {};

        props.key = columnIndex;
        props.index = columnIndex;
        props.sort = this.state.sortBy == columnIndex ? this.state.sortOrder : undefined;
        props.align = column.align;
        props.style = {fontSize:'90%'};


        let onColumnClick = (event) => {

            let index = event.target.attributes['index'].value;

            if (this.props.columns[index] != undefined) {
                let column = this.props.columns[index];
    
                if (column.value) {
    
                    let rows = this.props.rows;
                    let sortOrder = this.state.sortOrder;
                    let sortBy = this.state.sortBy;
                    let rowOrder = this.state.rowOrder;
    
                    if (sortOrder == 'descending' || sortBy != index) {
                        rowOrder = rowOrder.sort((a, b) => {
                            let rowA = rows[a];
                            let rowB = rows[b];
                            return column.value(rowA) > column.value(rowB);
                        });
    
                        sortOrder = 'ascending';
                    }
                    else {
                        rowOrder = rowOrder.sort((a, b) => {
                            let rowA = rows[a];
                            let rowB = rows[b];
                            return column.value(rowA) < column.value(rowB);
                        });
    
                        sortOrder = 'descending';
                    }
    
                    this.setState({rowOrder:rowOrder, sortBy:index, sortOrder:sortOrder});
                }
            }            
        }


        if (typeof(column.value) == 'function') {

            props.onClick = onColumnClick;

        }

        return (
            <QED.Column {...props}>
                {column.name}
            </QED.Column>
        );
    }




    renderColumns() {
        let columns = this.columns.map((column, columnIndex) => {
            return this.renderColumn(column, columnIndex);
        });

        return (
            <QED.Columns>
                {columns}
            </QED.Columns>

        );            

    }

    renderHeader() {
        return (
            <QED.Header>
                {this.renderColumns()}
            </QED.Header>
        );

    }

    renderBody() {
        return (
            <QED.Body>
                {this.renderRows()}
            </QED.Body>
        );
    };


    computeRowOrder(sortBy, sortOrder) {

        let column = this.props.columns[sortBy];
        let rows = this.props.rows;

        if (column == undefined || column.value == undefined) {
            this.log('Not able to sort.');
            return null;
        }


        this.log('sorting by column', column);
        this.log('Sort Order', sortBy, sortOrder);

        let rowOrder = this.state.rowOrder.sort((a, b) => {
            let rowA = rows[a];
            let rowB = rows[b];
            let valueA = column.value(rowA);
            let valueB = column.value(rowB);

            let compare = valueA > valueB;

            return sortOrder == 'ascending' ? compare : !compare;


        });

        return rowOrder;
    }


    computeRowFilter(filter) {

        let rows = this.props.rows;

        filter = filter.toUpperCase();

        if (filter == '')
            return null;

        let filterRow = (row) => {

            if (filter == '')
                return row;

            for (let column of this.columns) {
                if (column.text) {
                    let value = column.text(row);
                    if (value) {
                        let text = value.toString();
                        if (text.toUpperCase().includes(filter)) {
                            return row;

                        }
                    }
                }
            }

        };

        let rowFilter = {};

        rows.forEach((row, index) => {
            if (filterRow(row))
                rowFilter[index] = row;

        })

        return rowFilter;

    }



    renderFilter() {


        let props = {};
        props.value = this.state.filter;

        props.onChange = (event) => {

            let target = event.target;
            let filter = target.value;

            this.setState({rowFilter:this.computeRowFilter(filter), filter:filter});

        };

        return (
            <div>
                <input style={{fontSize:'90%'}} placeholder='Långsamfilter' className="form-control" {...props}></input>
            </div>        
        );        
    }


    render() {
        return (
            <div>
                {this.renderFilter()}
                <QED>
                    <QED.Table style={{cursor:'default'}}>
                        {this.renderHeader()}
                        {this.renderBody()}
                    </QED.Table>
                </QED>

            </div>
        );
    }


}
